export const SUBJECT_OPTIONS = [
   {id: 1, subject: 'Experiencing problems with'},
   {id: 2, subject: 'Do not know how to'},
   {id: 3, subject: 'Suggest an improvement on existing feature'},
   {id: 4, subject: 'Suggest a new feature'},
   {id: 5, subject: 'Report a bug'},
   {id: 6, subject: 'General question'},
   {id: 7, subject: 'Request Enterprise Account Plan'},
   {id: 8, subject: 'Other'},
];